var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-discount-verification"},[(_vm.discountVerificationType === 'access')?_c('AccessPassVerification'):(_vm.discountVerificationType === 'nevada_rf')?_c('NevadaEBT'):(_vm.discountVerificationType === 'metro_rf')?_c('MetroPassVerification'):_c('PasscodeVerification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }